<template>
    <div>
        <modal-share-house class="not-publish-modal" :display="modalStatus.notPublish" @modalStatus="closeModal" >
            <div class="not-publish-modal-wrap">
                <div class="content">
                    <img src="@/assets/img/shareHouse/warn.svg" alt="" srcset="">
                   抱歉！此房源已下架
                </div>
            </div>
        </modal-share-house>
    </div>
</template>
<script>
import ModalShareHouse from '@/components/widge/ModalShareHouse.vue';
import { mapGetters } from 'vuex'

export default {
    methods: {
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'notPublish'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        ModalShareHouse,
    }
}
</script>
<style lang="scss" scoped>
    #modal.not-publish-modal{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 450px;
            height: 418px;
            padding: 0 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .not-publish-modal-wrap{
                    padding: 0 32px 0 32px;
                    .content{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-size: 24px;
                        font-weight: 600;
                        img{
                            margin-bottom: 40px;
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        #modal.not-publish-modal{
            .modal-content{
                width: 284px;
                height: 230px;
                .detail{
                    .not-publish-modal-wrap{
                        .content{
                            font-size: 16px;
                            img{
                                width: 50px;
                                margin-bottom: 30px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/notPublish.vue